import styled from 'styled-components';

export const ContentText = styled.div`
  &:first-letter {
    text-transform: capitalize;
  }
  font: 300 14px 'work_sans';
  color: #5a5a5a;
  margin-top: 28px;
  margin-bottom: 13px;
  align-self: center;
  text-align: center;
  margin: 10px;

  strong {
    font: bold 15px 'work_sans';
  }

  a,
  a:hover {
    font: bold 14px 'work_sans';
    color: #8bac2a;
    text-decoration: none;
  }
`;
